import { ExclamationCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const StyledExclamationCircleOutlined = styled(
    ExclamationCircleOutlined,
)`
    font-size: 24px;
    color: ${({ theme }) => theme.dangerTypographyColor};
`;
